"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersioningType = void 0;
/**
 * @publicApi
 */
var VersioningType;
(function (VersioningType) {
    VersioningType[VersioningType["URI"] = 0] = "URI";
    VersioningType[VersioningType["HEADER"] = 1] = "HEADER";
    VersioningType[VersioningType["MEDIA_TYPE"] = 2] = "MEDIA_TYPE";
    VersioningType[VersioningType["CUSTOM"] = 3] = "CUSTOM";
})(VersioningType || (exports.VersioningType = VersioningType = {}));
